import axios from "axios";
import * as types from "../mutation-types";
import logger from "~/utilities/logger";

// state
export const state = {
  tangle: null,
  strings: null,
  context: null,
};

// getters
export const getters = {
  context: (state) => state.context,
  check_context: (state) => state.context !== null,
};

export const actions = {
  async fetchTangle(context)
  {
    axios
      .get("/api/v1/tangle")

      .then((response) =>
      {
        // logger.log(response);
        logger.log(response.data);
        // context.commit("tangle",response.data); //tangle will be run from mutation
        context("tangle", response.data);
      })
      .catch(() =>
      {
        logger.log("Error...tangle.....");
      });
  },

  async fetchStrings(context)
  {
    axios
      .get("/api/v1/strings")

      .then((response) =>
      {
        // logger.log(response);
        logger.log(response.data);
        context.commit("strings", response.data); //strings will be run from mutation
      })
      .catch(() =>
      {
        logger.log("Error....strings....");
      });
  },

  fetchContext({ commit })
  {
    axios
      .get("/api/v1/context")

      .then((response) =>
      {
        // logger.log(response);
        logger.log(response.data);
        // context.commit("context",response.data); //context will be run from mutation
        commit("context", response.data); //context will be run from mutation
      })
      .catch(() =>
      {
        logger.log("Error...context.....");
      });
  },
};

// mutations
export const mutations = {
  tangle(state, data)
  {
    return (state.tangle = data);
  },
  strings(state, data)
  {
    return (state.strings = data);
  },
  context(state, data)
  {
    state.context = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
